import createAction from 'redux-actions/es/createAction';

import { FETCH_STORE } from './consts/types';

export { findStoreById } from '@esentai/core/features/stores/actions';

export const fetchStore = createAction(FETCH_STORE);
